// Check if value is empty, return default value
const getValueDef = (data, def) => {
    return data == undefined || data == null ? def : data;
}

// Convert field mapping to array
const field2array = (field) => {
    if (!(field instanceof Array)) {
        // Field conversion
        // Handle . split
        field = field.split('.');
        let fds = [];
        field.forEach(x => {
            if (!x) {
                return;
            }
            // Handle [] array
            let tfs = x.split('[');
            if (tfs.length <= 1) {
                fds.push(x);
            } else {
                tfs.forEach(y => {
                    if (!y) {
                        return;
                    }
                    fds.push(y.endsWith(']') ? +(y.substr(0, y.length - 1)) : y);
                });
            }
        });
        field = fds;
    }
    return field;
}

// Extract fields from object, return default field if not found
const getFieldValue = (data, field, def) => {
    def = getValueDef(def, '');
    if (!data || !field) {
        return def;
    }
    let fields = field2array(field);
    let value = data;
    for (let idx in fields) {
        let fd = fields[idx];
        value = value && value[fd];
        if (value == undefined || value == null) {
            return def;
        }
    }
    return value;
}

const setFieldValue = (data, field, value) => {
    if (!data) {
        return;
    }
    let fields = field2array(field);

    let node = data;
    for (let i = 0; i < fields.length; i++) {
        let fd = fields[i];

        if (i + 1 == fields.length) {
            // Last stage
            node[fd] = value;
            return;
        }

        let nfd = fields[i + 1];
        // Intermediate variable
        if (typeof (node[fd]) === 'object') {
            if (typeof (nfd) === 'number') {
                if (!(node[fd] instanceof Array)) {
                    node[fd] = [];
                }
            } else {
                if (node[fd] instanceof Array) {
                    node[fd] = {};
                }
            }
        } else {
            node[fd] = typeof (nfd) === 'number' ? [] : {};
        }
        node = node && node[fd];
    }
}

const initFieldValue = (data, field, def) => {
    let val = getFieldValue(data, field, def);
    setFieldValue(data, field, val);
}

const data2field = (data) => {
    let fields = [];
    const isLeafNode = (node) => {
        if (node == null || node == undefined) {
            return true;
        }
        if (typeof (node) != 'object') {
            return true;
        }
        let count = 0;
        for (let key in node) {
            count++;
        }
        return count == 0;
    }
    const scanData = (data, fields, parentField) => {
        for (let key in data) {
            let node = data[key];
            let nfield = null;
            if (data instanceof Array) {
                nfield = parentField ? parentField + '[' + key + ']' : key;
            } else {
                nfield = parentField ? parentField + '.' + key : key;
            }
            if (isLeafNode(node)) {
                fields.push({ field: nfield, data: node });
            } else {
                scanData(node, fields, nfield);
            }
        }
    }
    scanData(data, fields, '');
    return fields;
}

const initField = (data, defData) => {
    if (!data || !defData) {
        return;
    }
    let fields = data2field(defData);
    for (let i in fields) {
        let field = fields[i];
        setFieldValue(data, field.field, field.data);
    }
}

export default {
    getValueDef,
    getFieldValue,
    field2array,
    setFieldValue,
    initFieldValue,
    data2field,
    initField,
};
